import { defineComponent as _defineComponent } from 'vue';
import PRadioButton from 'primevue/radiobutton';
import PButton from 'primevue/button';
import BActionsModal from '~/components/general/BActionsModal.vue';
import CancelIcon from '~/components/general/icons/IconCancelCircle.vue';
import SuccessIcon from '~/components/general/icons/IconSuccessCircle.vue';
import { TICKET_FORMATS } from '~/utils/utils';

// eslint-disable-next-line no-unused-vars
var TicketFormatSupportedStates = /*#__PURE__*/function (TicketFormatSupportedStates) {
  // eslint-disable-next-line no-unused-vars
  TicketFormatSupportedStates["BOTH"] = "both";
  // eslint-disable-next-line no-unused-vars
  TicketFormatSupportedStates["SECURE"] = "secure";
  // eslint-disable-next-line no-unused-vars
  TicketFormatSupportedStates["PDF"] = "pdf";
  return TicketFormatSupportedStates;
}(TicketFormatSupportedStates || {});
export default /*#__PURE__*/_defineComponent({
  __name: 'TicketFormatSelector',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    secureFormatSupported: {
      type: Boolean,
      default: false
    },
    pdfFormatSupported: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'ticketFormatSelected'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var selectedTicketFormat = ref('');
    var ticketFormatSupportedState = computed(function () {
      if (props.secureFormatSupported && props.pdfFormatSupported) return TicketFormatSupportedStates.BOTH;
      if (props.secureFormatSupported) return TicketFormatSupportedStates.SECURE;
      return TicketFormatSupportedStates.PDF;
    });
    var modalText = computed(function () {
      switch (ticketFormatSupportedState.value) {
        case TicketFormatSupportedStates.BOTH:
          return {
            title: t('ticketFormatSelector.both.title'),
            subtitle: t('ticketFormatSelector.both.subtitle')
          };
        case TicketFormatSupportedStates.SECURE:
          return {
            title: t('ticketFormatSelector.secure.title'),
            subtitle: t('ticketFormatSelector.secure.subtitle')
          };
        case TicketFormatSupportedStates.PDF:
          return {
            title: t('ticketFormatSelector.pdf.title'),
            subtitle: t('ticketFormatSelector.pdf.subtitle')
          };
        default:
          // fallback (should never happen)
          return {
            title: '',
            subtitle: ''
          };
      }
    });
    var radioButtonOptions = computed(function () {
      var options = [];
      if (props.secureFormatSupported) {
        options.push({
          value: TICKET_FORMATS.SECURE,
          group: 'selectTicketFormat',
          title: t('ticketFormatSelector.options.digital.title'),
          subtitle: t('ticketFormatSelector.options.digital.subtitle'),
          commodities: [{
            text: t('ticketFormatSelector.options.digital.commodity1'),
            icon: 'checkmark'
          }, {
            text: t('ticketFormatSelector.options.digital.commodity2'),
            icon: 'checkmark'
          }, {
            text: t('ticketFormatSelector.options.digital.commodity3'),
            icon: 'checkmark'
          }],
          recommended: true
        });
      }
      if (props.pdfFormatSupported) {
        options.push({
          value: TICKET_FORMATS.PDF,
          group: 'selectTicketFormat',
          title: t('ticketFormatSelector.options.pdf.title'),
          subtitle: t('ticketFormatSelector.options.pdf.subtitle'),
          commodities: [{
            text: t('ticketFormatSelector.options.pdf.commodity1'),
            icon: 'checkmark'
          }, {
            text: t('ticketFormatSelector.options.pdf.commodity2'),
            icon: 'checkmark'
          }, {
            text: t('ticketFormatSelector.options.digital.commodity3'),
            icon: 'cancel'
          }],
          recommended: false
        });
      }
      return options;
    });
    var confirmButtonText = computed(function () {
      if (selectedTicketFormat.value === TICKET_FORMATS.SECURE) {
        return t('ticketFormatSelector.button.digitalTicket');
      } else {
        return t('ticketFormatSelector.button.pdfTicket');
      }
    });
    onMounted(function () {
      selectedTicketFormat.value = radioButtonOptions.value[0].value;
    });
    function closeDialog() {
      emit('close');
    }
    function handleTicketFormatSelection() {
      emit('ticketFormatSelected', selectedTicketFormat.value);
    }
    return {
      __sfc: true,
      TicketFormatSupportedStates: TicketFormatSupportedStates,
      props: props,
      emit: emit,
      t: t,
      selectedTicketFormat: selectedTicketFormat,
      ticketFormatSupportedState: ticketFormatSupportedState,
      modalText: modalText,
      radioButtonOptions: radioButtonOptions,
      confirmButtonText: confirmButtonText,
      closeDialog: closeDialog,
      handleTicketFormatSelection: handleTicketFormatSelection,
      PRadioButton: PRadioButton,
      PButton: PButton,
      BActionsModal: BActionsModal,
      CancelIcon: CancelIcon,
      SuccessIcon: SuccessIcon
    };
  }
});